import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import axios from "../../axios";
import { errorToast } from "../../utils/toast";
import { useUser } from "../../hooks/use-user";

import { Riple } from "react-loading-indicators";
import { FaEnvelope, FaEnvelopeSquare, FaWhatsapp } from "react-icons/fa";

const AuthenticationContext = createContext(null);

const ON_HOLD_EXCLUDED_PATHS = [
  "/dash/plan",
  "/dash/checkout",
  "/dash/profile",
  "/dash/profileNew",
  "/dash/support",
  "/dash/leaderBoard",
  "/dash/current-affairs",
  "/dash/state-gk",
  "/dash/kyc-status",
  "/dash/bank-details",
  "/courses",
  "/profile",
  "/UserDetailPage",
];

const isAccountOnHold = (user) => {
  const onHoldValue = user?.onHold;
  console.log(onHoldValue,"onHoldValue")
  const statusValue = String(user?.status || "").toLowerCase();

  return (
    onHoldValue === true ||
    onHoldValue === 1 ||
    String(onHoldValue).toLowerCase() === "true" ||
    statusValue === "onhold" ||
    statusValue === "on_hold"
  );
};

const AccountOnHoldPopup = ({ user }) => {
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const accountOnHold = isAccountOnHold(user);

  useEffect(() => {
    setDismissed(false);
  }, [location.pathname, accountOnHold]);

  const isExcludedPath = ON_HOLD_EXCLUDED_PATHS.some((path) =>
    location.pathname.startsWith(path),
  );

  if (!accountOnHold || isExcludedPath || dismissed) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 px-4">
      <div className="w-full max-w-sm rounded-[28px] bg-white px-6 py-8 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-red-100 text-2xl font-bold text-red-600">
          !
        </div>

        <h2 className="mb-2 text-2xl font-bold text-gray-900">
          Account on Hold
        </h2>
        <p className="mb-7 text-sm text-gray-600">
          Your account is on hold. Please contact support.
        </p>

        <p className="mb-4 text-base font-medium text-gray-800">
          Contact Support
        </p>

<div className="mb-3 flex items-center justify-center gap-3 text-sm text-gray-700">
  <FaEnvelopeSquare className="text-lg text-gray-600" />
  {/* <a href="mailto:support@adhyayi.com" className="underline"> */}
    support@adhyayi.com
  {/* </a> */}
</div>
<div className="mb-8 flex items-center justify-center gap-3 text-sm text-gray-700">
  <FaWhatsapp className="text-xl text-gray-500" />
  <a
    href="https://wa.me/917067373846"
    target="_blank"
    rel="noopener noreferrer"
  >
    +91 70673 73846
  </a>
</div>

        <button
          type="button"
          onClick={() => setDismissed(false)}
          className="w-full rounded-xl bg-[#4B2D83] py-3 text-base font-semibold text-white shadow-md"
        >
          Okay
        </button>
      </div>
    </div>
  );
};

const Authentication = ({ children }) => {
  const { data: authenticatedUser, isLoading, isError, error } = useUser();

  // -------------------------------------------------
  // 1️⃣ BROADCAST CHANNEL — Cross-tab Logout
  // -------------------------------------------------
  useEffect(() => {
    const bc = new BroadcastChannel("auth");

    bc.onmessage = (event) => {
      if (event.data === "logout") {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    };

    return () => bc.close();
  }, []);

  // -------------------------------------------------
  // 2️⃣ Handle auth errors from useUser
  // -------------------------------------------------
  useEffect(() => {
    if (isError && error?.response?.status === 401) {
      localStorage.removeItem("token");
      const bc = new BroadcastChannel("auth");
      bc.postMessage("logout");
      window.location.href = "/login";
    } else if (isError) {
      errorToast(error?.response?.data?.Comments || "Something went wrong");
    }
  }, [isError, error]);

  if (isLoading) return <Riple color="#000000" size="medium" text="" textColor="" />;

  return (
    <AuthenticationContext.Provider value={authenticatedUser}>
      {children}
      <AccountOnHoldPopup user={authenticatedUser} />
    </AuthenticationContext.Provider>
  );
};

export const useAuth = () => useContext(AuthenticationContext);

export default Authentication;
